import React from 'react';
import { FaEnvelopeOpenText, FaInstagram, FaBookOpen } from 'react-icons/fa6';

const contactOptions = [
  {
    IconComponent: FaInstagram,
    title: 'Instagram',
    description: 'DMs open for reader conversations, collaborations, and heartfelt reflections.',
    linkLabel: '@aarjay__s',
    href: 'https://www.instagram.com/aarjay__s/',
  },
  {
    IconComponent: FaEnvelopeOpenText,
    title: 'Email',
    description: 'For press, interviews, speaking engagements, or deeper literary conversations.',
    linkLabel: 'aarjay.scribe@yahoo.com',
    href: 'mailto:aarjay.scribe@yahoo.com',
  },
  {
    IconComponent: FaBookOpen,
    title: 'Book Availability',
    description: 'Find The Arid Lips on Amazon and other major storefronts worldwide.',
    linkLabel: 'See on Amazon',
    href: 'https://www.amazon.com/dp/B0FD369KK8',
  },
];

const Contact: React.FC = () => {
  return (
    <section id="contact" className="section section--muted">
      <div className="wrapper">
        <div className="section__header">
          <span className="eyebrow">Let’s Connect</span>
          <h2 className="headline">Share Your Story with Me</h2>
          <p className="lead">
            I would love to hear how my words met you—whether on a quiet night, during a long commute,
            or in a moment that asked for courage. Reach out through any of the channels below.
          </p>
        </div>

        <div className="grid grid--two">
          <div className="surface">
            <div className="stack">
              <div className="media-frame">
                <img
                  src="/editorial-correspondence.png"
                  alt="Correspondence — an arched editorial plate with the author's monogram seal"
                  className="media media--framed"
                  style={{ maxWidth: '360px' }}
                />
              </div>
              <p className="text-muted" style={{ margin: 0 }}>
                Whether you&apos;re a reader reaching out with your reflections, a fellow writer
                searching for resonance, or a collaborator imagining what we can build together—my
                inbox is open. Every note is read with care.
              </p>
            </div>
          </div>

          <div className="stack">
            {contactOptions.map((option) => {
              const Icon = option.IconComponent as React.ComponentType;
              return (
                <div key={option.title} className="contact-card">
                  <div className="contact-card__icon">
                    <Icon />
                  </div>
                  <div className="stack" style={{ gap: '0.5rem' }}>
                    <h3 style={{ margin: 0, fontFamily: 'Cormorant Garamond, serif' }}>
                      {option.title}
                    </h3>
                    <p className="text-muted" style={{ margin: 0 }}>
                      {option.description}
                    </p>
                    <a
                      href={option.href}
                      className="pill-link"
                      target={option.href.startsWith('http') ? '_blank' : undefined}
                      rel={option.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                    >
                      {option.linkLabel}
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;

